// extracted by mini-css-extract-plugin
export var buttons = "bg_cp";
export var container = "bg_h";
export var image = "bg_k";
export var innerText = "bg_dP";
export var logo = "bg_bn";
export var p = "bg_dQ";
export var section = "bg_j";
export var short = "bg_dR";
export var tall = "bg_dS";
export var textContainer = "bg_bV";